export default "__VITE_ASSET__BMNLBEIB__"